import CloudSyncOutlinedIcon from "@mui/icons-material/CloudSyncOutlined";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "dataops", spoke: "dataops", title: "Data", icon: CloudSyncOutlinedIcon, order: 63, entries: [
  { label: "Import data", to: "/app/dataops/imports", permission: "dataops.import.run" },
  { label: "Import jobs", to: "/app/dataops/imports/history", permission: "dataops.import.view" },
  { label: "Data quality", to: "/app/dataops/quality", permission: "dataops.quality.view" },
  { label: "Export & deletion", to: "/app/dataops/tenant", permission: "dataops.tenant.export" },
] });
